import React, {useRef, useCallback} from "react";
import classNames from "classnames";
import {useSelector} from "react-redux";
import ReactGA from 'react-ga';

import {textMap} from "../common/Localization";

import './WhyMinimap.scss';

const WhyMinimap = () => {
	const id = useSelector(state => state.ScrollModule.id);

	const showMinimap1 = useRef();
	const showMinimap2 = useRef();
	const showMinimap3 = useRef();

	const video1 = useRef();
	const video2 = useRef();
	
	if(!showMinimap1.current && id === "whyMinimap1") {
		showMinimap1.current = true;
	}
	if(!showMinimap2.current && id === "whyMinimap2") {
		showMinimap2.current = true;
	}
	if(!showMinimap3.current && id === "whyMinimap3") {
		showMinimap3.current = true;
	}

	if(video1.current != null) {
		if(id === "whyMinimap1") {
			video1.current.play();
		} else {
			video1.current.pause();
		}
	}

	if(video2.current != null) {
		if(id === "whyMinimap3") {
			video2.current.play();
		} else {
			video2.current.pause();
		}
	}

	const sendGa1 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-광고",
			label:"왜미니맵-첫번째"
		});
	}, []);
	const sendGa2 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-광고",
			label:"왜미니맵-두번째"
		});
	}, []);
	const sendGa3 = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-광고",
			label:"왜미니맵-세번째"
		});
	}, []);

	return (
		<>
		<div id="whyMinimap1" className="view_section">
			<div className="why_minimap_wrap">
				<div className={classNames("title", "c_28")}>{textMap.formatString(textMap.why_minimap_title, <span className={classNames("minimap_tag", "c_blue", "cbc_light_blue")}>{textMap.why_minimap_title_2}</span>)}</div>
				<div className="section_1">
					<div className="text_wrap">
						<div className={classNames("section_title", "c_28")}>{textMap.formatString(textMap.w_m_section_1_title, <span className="c_blue">{textMap.w_m_section_1_title_2}</span>)}</div>
						<div className={classNames("section_description", "c_5b")}>{textMap.w_m_section_1_desc_1}</div>
						<div className={classNames("section_description", "c_5b")}>{textMap.w_m_section_1_desc_2}</div>
						<div className="button_wrap">
							<span className={classNames("button", "c_blue")}>
								<a href="https://minimap2.imweb.me/#doz_body" target="_blank" rel="noopener noreferrer" onClick={sendGa1}>
									{textMap.w_m_section_1_button}
									<img src={process.env.PUBLIC_URL + "/icon/arrow_right_blue.png"} alt=""/>
								</a>
							</span>
						</div>
					</div>
					<div className="image_wrap">
						<div className={classNames("background", "cbc_light_blue")}></div>
						<video loop={true} muted={true} ref={video1} playsInline={true}>
							<source src={process.env.PUBLIC_URL + "/video/Video01.mp4"} type="video/mp4" />
						</video>
						<img className="mockup" src={process.env.PUBLIC_URL + "/img/mockup.png"} alt=""/>
						<div className="item_wrap">
							<img className={classNames("game_item", "game_item_1", showMinimap1.current ? "show" : "")} src={process.env.PUBLIC_URL + "/img/game_item_1.png"} alt=""/>
							<img className={classNames("game_item", "game_item_2", showMinimap1.current ? "show" : "")} src={process.env.PUBLIC_URL + "/img/game_item_2.png"} alt=""/>
							<img className={classNames("game_item", "game_item_3", showMinimap1.current ? "show" : "")} src={process.env.PUBLIC_URL + "/img/game_item_3.png"} alt=""/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="whyMinimap2" className="view_section">
			<div className="why_minimap_wrap">
				<div className="section_2">
					<div className="image_wrap">
						<div className={classNames("background", "lc_light_blue")}></div>
						<div className={classNames("foreground", "sc_box", "bc_ff")}>
							<div className={classNames("info_title", "c_5b")}>{textMap.w_m_section_2_info_1}</div>
							<div className={classNames("info_description", "c_95")}>{textMap.w_m_section_2_info_2}</div>
							<div className="bar_chart"><span className={classNames("bar_background", "bar_1", "cbc_dark_blue")} style={{width:showMinimap2.current ? 40*2.1 + "%" : 0}}></span><span className={classNames("bar", "c_light_blue")} style={{width:40*2.1 + "%"}}>{textMap.w_m_section_2_info_3}</span><span className="c_69">40.0%</span></div>
							<div className="bar_chart"><span className={classNames("bar_background", "bar_2", "cbc_dark_blue")} style={{width:showMinimap2.current ? 39.2*2.1 + "%" : 0}}></span><span className={classNames("bar", "c_light_blue")} style={{width:39.2*2.1 + "%"}}>{textMap.w_m_section_2_info_4}</span><span className="c_69">39.2%</span></div>
							<div className="bar_chart"><span className={classNames("bar_background", "bar_3", "cbc_blue")} style={{width:showMinimap2.current ? 21.4*2.1 + "%" : 0}}></span><span className={classNames("bar", "c_light_blue")} style={{width:21.4*2.1 + "%"}}>{textMap.w_m_section_2_info_5}</span><span className="c_69">21.4%</span></div>
							<div className="bar_chart"><span className={classNames("bar_background", "bar_4", "cbc_blue")} style={{width:showMinimap2.current ? 20.1*2.1 + "%" : 0}}></span><span className={classNames("bar", "c_light_blue")} style={{width:20.1*2.1 + "%"}}>{textMap.w_m_section_2_info_6}</span><span className="c_69">20.1%</span></div>
							<div className="bar_chart"><span className={classNames("bar_background", "bar_5", "cbc_blue")} style={{width:showMinimap2.current ? 17.1*2.1 + "%" : 0}}></span><span className={classNames("bar", "c_light_blue")} style={{width:17.1*2.1 + "%"}}>{textMap.w_m_section_2_info_7}</span><span className="c_69">17.1%</span></div>
							<div className="bar_chart"><span className={classNames("bar_background", "bar_6", "cbc_blue")} style={{width:showMinimap2.current ? 15.2*2.1 + "%" : 0}}></span><span className={classNames("bar", "c_light_blue")} style={{width:15.2*2.1 + "%"}}>{textMap.w_m_section_2_info_8}</span><span className="c_69">15.2%</span></div>
							<div className="bar_chart"><span className={classNames("bar_background", "bar_7", "cbc_blue")} style={{width:showMinimap2.current ? 13.0*2.1 + "%" : 0}}></span><span className={classNames("bar", "c_light_blue")} style={{width:13.0*2.1 + "%"}}>{textMap.w_m_section_2_info_9}</span><span className="c_69">13.0%</span></div>
							<div className="bar_chart"><span className={classNames("bar_background", "bar_8", "cbc_blue")} style={{width:showMinimap2.current ? 11.9*2.1 + "%" : 0}}></span><span className={classNames("bar", "c_light_blue")} style={{width:11.9*2.1 + "%"}}>{textMap.w_m_section_2_info_10}</span><span className="c_69">11.9%</span></div>
							<div className={classNames("info_help", "c_b2")}>{textMap.w_m_section_2_info_11}</div>
						</div>
					</div>
					<div className="text_wrap">
						<div className={classNames("section_title", "c_28")}>{textMap.formatString(textMap.w_m_section_2_title, <span className="c_blue">{textMap.w_m_section_2_title_2}</span>)}</div>
						<div className={classNames("section_description", "c_5b")}>{textMap.w_m_section_2_desc_1}</div>
						<div className={classNames("section_description", "c_5b")}>{textMap.w_m_section_2_desc_2}</div>
						<div className="button_wrap">
							<span className={classNames("button", "c_blue")}>
								<a href="https://minimap2.imweb.me/#doz_body" target="_blank" rel="noopener noreferrer" onClick={sendGa2}>
									{textMap.w_m_section_2_button}
									<img src={process.env.PUBLIC_URL + "/icon/arrow_right_blue.png"} alt=""/>
								</a>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="whyMinimap3" className="view_section">
			<div className="why_minimap_wrap">
				<div className="section_3">
					<div className="text_wrap">
						<div className={classNames("section_title", "c_28")}>{textMap.formatString(textMap.w_m_section_3_title, <span className="c_blue">{textMap.w_m_section_3_title_2}</span>)}</div>
						<div className={classNames("section_description", "c_5b")}>{textMap.w_m_section_3_desc_1}</div>
						<div className={classNames("section_description", "c_5b")}>{textMap.w_m_section_3_desc_2}</div>
						<div className={classNames("section_description", "c_5b")}>{textMap.w_m_section_3_desc_3}</div>
						<div className="button_wrap">
							<span className={classNames("button", "c_blue")}>
								<a href="https://minimap2.imweb.me/#doz_body" target="_blank" rel="noopener noreferrer" onClick={sendGa3}>
									{textMap.w_m_section_3_button}
									<img src={process.env.PUBLIC_URL + "/icon/arrow_right_blue.png"} alt=""/>
								</a>
							</span>
						</div> 
					</div>
					<div className="image_wrap">
						<div className={classNames("background", "cbc_light_blue")}></div>
						<video loop={true} muted={true} ref={video2} playsInline={true}>
							<source src={process.env.PUBLIC_URL + "/video/Video02.mp4"} type="video/mp4" />
						</video>
						<img className="mockup" src={process.env.PUBLIC_URL + "/img/mockup.png"} alt=""/>
						
						<div className="item_wrap">
							<span className={classNames("comment", "comment_1", "bc_ff", "c_3b", "sc_comment", showMinimap3.current ? "show" : "")}>
								<img className={classNames("profile_image")} src={process.env.PUBLIC_URL + "/icon/profile_red.png"} alt=""/>
								<span className={classNames("comment_text")}>{textMap.w_m_comment_1}</span>
							</span>
							<span className={classNames("comment", "comment_2", "bc_ff", "c_3b", "sc_comment", showMinimap3.current ? "show" : "")}>
								<img className={classNames("profile_image")} src={process.env.PUBLIC_URL + "/icon/profile_orange.png"} alt=""/>
								<span className={classNames("comment_text")}>{textMap.w_m_comment_2}</span>
							</span>
							<span className={classNames("comment", "comment_3", "bc_ff", "c_3b", "sc_comment", showMinimap3.current ? "show" : "")}>
								<img className={classNames("profile_image")} src={process.env.PUBLIC_URL + "/icon/profile_green.png"} alt=""/>
								<span className={classNames("comment_text")}>{textMap.w_m_comment_3}</span>
							</span>
						</div>
						
					</div>
				</div>

			</div>
		</div>
		</>
	);
};

export default WhyMinimap;
